import { useState } from 'react';
import { useAdminAuth } from '../AuthContext';
import { Lock } from 'lucide-react';

export default function AdminLogin() {
  const { login } = useAdminAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(email, password);
    } catch (err) {
      setError(err.message || 'Invalid credentials');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0f0f0f] flex items-center justify-center px-4" data-testid="admin-login-page">
      <div className="w-full max-w-sm">
        {/* Logo */}
        <div className="text-center mb-8">
          <div className="font-bebas text-3xl text-white tracking-widest">WITT MACHINE</div>
          <div className="font-inter text-xs text-orange-500 tracking-widest uppercase mt-0.5">Admin Content Studio</div>
        </div>

        <div className="bg-[#111111] border border-white/10 p-8">
          <div className="flex items-center gap-2 mb-6">
            <Lock size={16} className="text-orange-500" />
            <h1 data-testid="admin-login-heading" className="font-bebas text-xl text-white tracking-wider">SIGN IN</h1>
          </div>

          {error && (
            <div data-testid="admin-login-error" className="bg-red-500/10 border border-red-500/30 text-red-400 font-inter text-sm px-4 py-3 mb-5">
              {error}
            </div>
          )}

          <form data-testid="admin-login-form" onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block font-inter text-xs text-zinc-500 uppercase tracking-widest mb-2">Email</label>
              <input
                data-testid="admin-email-input"
                type="email"
                required
                value={email}
                onChange={e => setEmail(e.target.value)}
                className="w-full bg-[#1e1e1e] border border-white/10 focus:border-orange-500 text-white font-inter text-sm px-4 py-3 outline-none transition-colors placeholder-zinc-600"
                placeholder="admin@wittmachine.com"
              />
            </div>
            <div>
              <label className="block font-inter text-xs text-zinc-500 uppercase tracking-widest mb-2">Password</label>
              <input
                data-testid="admin-password-input"
                type="password"
                required
                value={password}
                onChange={e => setPassword(e.target.value)}
                className="w-full bg-[#1e1e1e] border border-white/10 focus:border-orange-500 text-white font-inter text-sm px-4 py-3 outline-none transition-colors placeholder-zinc-600"
                placeholder="••••••••"
              />
            </div>
            <button
              data-testid="admin-login-submit"
              type="submit"
              disabled={loading}
              className="w-full bg-orange-500 hover:bg-orange-600 disabled:opacity-60 text-white font-bebas text-lg tracking-widest py-3 transition-colors"
            >
              {loading ? 'SIGNING IN...' : 'SIGN IN'}
            </button>
          </form>
        </div>

        <p className="text-center font-inter text-xs text-zinc-700 mt-4">
          Witt Machine Admin — Authorized Access Only
        </p>
      </div>
    </div>
  );
}
